<template>
  <div class="product-configuration-steps" v-if="!loading && phone">

    <div class="popup-select-store-message" v-if="popup">
      <div class="backdrop" @click="closePopup"></div>
      <div class="box">
        <div class="close" @click="closePopup"><span class="fi-rr-cross"></span></div>
        <p>Vous devez choisir un magasin pour pouvoir continuer la configuration de votre futur téléphone</p>
        <p><a href="" @click.prevent="openStorePopup" class="btn btn-primary btn-small">Choisir un magasin</a></p>
      </div>
    </div>

    <div class="product-name">
      <h1>{{ phone.name }}</h1>
      <p class="attributes">
        <span class="storage" v-if="currentStorage">{{ currentStorage.toLowerCase() }}</span>
        <span class="color"><i :style="{ backgroundColor: '#' + currentColor }"></i>{{ phone.defaults.color.nom.toLowerCase() }}</span>
      </p>
    </div>

    <Step :active="true" @open="openStep">
      <Loader v-if="storesLoading || stockLoading"/>
      <Store v-model="store" @change="reloadPhone"/>
      <Stock/>
    </Step>

    <Step :active="currentStep === 1" :passed="currentStep > 1" :step="1" label="Personnalisons votre téléphone" @open="openStep">
      <Loader v-if="load"/>
      <Color v-model="query.color" label="Quelle finition préférez-vous ?" @change="reloadPhone"/>
      <Storage v-model="query.storage" label="Choisissez la capacité qui vous convient" @change="reloadPhone"/>
      <div class="next-step" v-if="query.id && query.color && query.storage && selectedStore">
        <a href="" @click.prevent="nextStep(2)" class="btn btn-primary btn-small">Valider et continuer</a>
      </div>
      <div class="next-step" v-if="query.id && query.color && query.storage && !selectedStore">
        <a href="" @click.prevent="openStorePopup" class="btn btn-primary btn-small">Choisir un magasin</a>
      </div>
    </Step>

    <Step :active="currentStep === 2" :passed="currentStep > 2" :step="2" label="Choisissons votre forfait" @open="openStep">
      <Loader v-if="load"/>
      <Subscription v-model="query.subscription" label="Choisissez votre nouveau forfait" @change="reloadPhone" @changeProvider="changeProvider"/>
      <div class="next-step" v-if="query.id && query.color && query.storage && selectedStore && selectedStore.stock > 0 && !stockLoading">
        <a href="" @click.prevent="nextStep(3)" class="btn btn-primary btn-small">Valider et continuer</a>
      </div>
    </Step>

    <Step :active="currentStep ===3" :passed="currentStep > 3" :step="3" label="Offres et remises" @open="openStep">
      <Loader v-if="load"/>
      <MoneyBack label-singular="Bon plan" label-plural="Bons plans"/>
    </Step>

  </div>
  <div class="product-configuration-loader" v-else>
    <div class="mark"></div>
  </div>
</template>

<script>
import Step from './Step'
import Loader from './Loader'
import Stock from './attributes/Stock'
import Color from './attributes/Color'
import Store from './attributes/Store'
import Storage from './attributes/Storage'
import TakeBack from './attributes/TakeBack'
import MoneyBack from './attributes/MoneyBack'
import Insurance from './attributes/Insurance'
import Subscription from './attributes/Subscription'

import { mapActions, mapState } from 'vuex'

export default {
  name: 'Configuration',
  props: {
    loading: Boolean,
    product: Number
  },
  data () {
    return {
      currentStep: 1,
      store: null,
      popup: false,
      query: {
        id: null,
        color: null,
        storage: null,
        subscription: null,
        insurance: null,
        hasInsurance: false,
        hasSubscription: true
      },
      inStock: false
    }
  },
  computed: {
    ...mapState({
      stockLoading: state => state.stores.stockLoading,
      selectedCode: state => state.stores.selected,
      stores: state => state.stores.items,
      phone: state => state.phone.item,
      buttonName: state => state.phone.button,
      load: state => state.phone.loading,
      insurances: state => state.phone.insurances,
      storesLoading: state => state.stores.loading
    }),
    currentColor () {
      let currentColor = 'FFFFFF'

      this.phone.colors.forEach((color) => {
        if(color.id === this.phone.defaults.color.id) currentColor = color.hex
      })

      return currentColor
    },
    currentStorage () {
      if(this.phone.defaults.storage){
        return this.phone.defaults.storage.capacite + ' ' + this.phone.defaults.storage.unit
      }

      return null
    },
    selectedStore () {
      let selectedStore = null

      this.stores.forEach((store) => {
        if(store.code === this.selectedCode) {
          selectedStore = store
        }
      })

      return selectedStore
    }
  },
  methods: {
    ...mapActions('phone', ['getPhone', 'saveEstimate']),
    ...mapActions('stores', ['getStocks', 'openPopup']),
    openStep (step) {
      if(this.currentStep > step.number) this.currentStep = step.number
      if(this.currentStep < step.number && !this.selectedStore) {
        this.popup = true
      }
    },
    saveEstimateTracking () {
      this.saveEstimate()
    },
    openStorePopup () {
      this.popup = false
      this.openPopup()
    },
    closePopup () {
      this.popup = false
    },
    nextStep(number) {
      this.currentStep = number
    },
    reloadPhone () {
      this.getPhone(this.query)
    },
    changeInsurance (value) {
      this.query.hasInsurance = value
      this.reloadPhone()
    },
    changeProvider (value) {
      this.query.hasSubscription = value
    },
    updateYoastBreadcrumb () {
      const breadcrumbElement = document.querySelector('.y-breadcrumb .container span.breadcrumb_last')
      breadcrumbElement.innerHTML = this.phone.seo_title
    }
  },
  watch: {
    phone () {
      this.query.id = (this.phone) ? parseInt(this.phone.id) : null
      this.query.color = (this.phone && this.phone.defaults && this.phone.defaults.color) ? this.phone.defaults.color : null
      this.query.storage = (this.phone && this.phone.defaults && this.phone.defaults.storage) ? this.phone.defaults.storage : null
      this.query.subscription = (this.phone && this.phone.defaults && this.phone.defaults.subscription) ? this.phone.defaults.subscription : null
      const url = new URL(this.phone.permalink)
      history.pushState(null, '', url.pathname)
      document.title = this.phone.seo_title + ' - Welcom'
      this.updateYoastBreadcrumb()
      this.getStocks({ packID: this.phone.packId })

      if (this.$gtm.enabled()) {
        window.dataLayer.push({
          page: 'product',
          name: this.phone.seo_title,
          url: this.phone.permalink,
          color: (this.phone && this.phone.defaults && this.phone.defaults.color) ? this.phone.defaults.color.nom : null,
          storage: (this.phone && this.phone.defaults && this.phone.defaults.storage) ? this.phone.defaults.storage.capacite + ' ' + this.phone.defaults.storage.unit : null,
          subscription: (this.phone && this.phone.defaults && this.phone.defaults.subscription) ? this.phone.defaults.subscription.libellePublic : null,
          insurance: (this.phone && this.phone.defaults && this.phone.defaults.insurance) ? this.phone.defaults.insurance.nom : null,
        })
      }
    }
  },
  components: {
    Step,
    Stock,
    Color,
    Store,
    Loader,
    Storage,
    TakeBack,
    MoneyBack,
    Insurance,
    Subscription
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

@keyframes slide {
  0% { @include transform(translateX(-50%) translateY(-200%) translateZ(0)); }
  100% { @include transform(translateX(-50%) translateY(200%) translateZ(0)); }
}

.mark{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  animation: slide 1s linear infinite;
  background: rgb(15,242,32);
  background: linear-gradient(0deg, rgba(darken(#f9f9f9, 3%), 1) 0%, rgba(darken(#f9f9f9, 6%), 1) 50%, rgba(darken(#f9f9f9, 3%), 1) 100%);
  @include transform(translateX(-50%) translateY(-50%) translateZ(0));
}

.product-configuration-steps{

  .popup-select-store-message{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000000;

    .backdrop{
      width: 100vw;
      height: 100vh;
      position: absolute;
      background-color: rgba($black, 0.9);
    }

    .box{
      max-width: 500px;
      background-color: $white;
      padding: 30px 70px;
      position: absolute;
      top: 50%;
      left: 50%;
      @include transform(translateX(-50%) translateY(-50%) translateZ(0));
      @include radius(10px);

      @include responsive(mobile){
        padding: 50px 30px 30px 30px;
        max-width: calc(100vw - 40px);
      }

      .close {
        width: 40px;
        height: 40px;
        position: absolute;
        top: 10px;
        right: 10px;
        text-align: center;
        line-height: 42px;
        color: $white;
        cursor: pointer;
        background-color: $primary;
        padding-left: 1px;
        @include radius(100%);
        @include transition();
      }

      p{
        text-align: center;
        line-height: px2rem(20px);
        margin-bottom: 20px;

        &:last-child{
          margin-bottom: 0;
        }
      }
    }
  }

  .product-name{
    margin-bottom: 20px;

    @include responsive(mobile) {
      display: none;
    }

    h1{
      font-weight: $fontSemiBold;
      font-size: px2rem(24px);
      line-height: px2rem(35px);
    }

    p{
      display: inline-block;
      width: 100%;
      font-size: px2rem(14px);
      line-height: px2rem(20px);
      color: rgba($black, 0.8);
      text-transform: capitalize;

      &.attributes{
        text-transform: capitalize;
        margin: 3px 0;

        span.storage, span.color{
          display: inline-block;
          height: 24px;
          line-height: 20px;
          padding: 0 5px;
          margin: 0 3px 0 0;
          border: 2px solid rgba($black, 0.1);
          font-weight: $fontBold;
          vertical-align: middle;
          @include box-sizing();
          @include radius(3px);
        }

        span.color{
          i{
            display: inline-block;
            width: 8px;
            height: 8px;
            margin-right: 4px;
            vertical-align: middle;
            @include transform(translateY(-1px));
            @include radius(100%);
          }
        }
      }
    }
  }

  .product-attributes{
    margin-bottom: 20px;
  }

  .next-step{
    a.btn{
      &.btn-red{
        background-color: $red;
        color: $white;
      }
    }
  }
}

.product-configuration-loader{
  background-color: darken(#f9f9f9, 3%);
  position: relative;
  overflow: hidden;
  min-height: 800px;
  @include radius(10px);
}
</style>
